/// <reference path="../../../app.definition.ts" />

import * as angular from "angular";
import { JavaApiAdapterService } from "@common/apiadapter/javaapi.service";
import { BroadcastService } from "@common/service/broadcast.service";
import { CacheService } from "@common/service/cache.service";
import { PushNotificationService } from "@common/service/push-notification.service";
import { ViewPortData } from "@common/model/ViewPortData";
import { IAppRootScopeService } from "@/app/app.definition";
import { Notification } from "../../model/notification";

interface IEcvPushNotification {
    notifications: Array<any>;
    init(): void;
    openEntity(notification: any): void;
}

class EcvPushNotification implements IEcvPushNotification {
    notifications: Array<any>;
    dataSet;
    pageSize = 10;
    itemTopIndex = 0;
    loading = false;
    totalCnt: number = 0;
    usrPswd;

    static $inject = ["CacheService", "PushNotificationService", "$rootScope", "$timeout",
        "$q", "BroadcastService", "ApiAdapterService", "$scope"];
    constructor(
        private $_cache: CacheService,
        private pnSrvc: PushNotificationService,
        private $rootScope: IAppRootScopeService,
        private $timeout: ng.ITimeoutService,
        private $q: ng.IQService,
        private BroadcastService: BroadcastService,
        private $api: JavaApiAdapterService,
        private $scope: ng.IScope
    ) {
        this.BroadcastService.registerCallBack('update-notifications', $rootScope.$id, () => {
            this.init();
        });
        this.BroadcastService.registerCallBack('reset-notifications', $rootScope.$id, () => {
            this.$_cache.setPushNotifications([]);
            this.fetchNotifications(0).then((n) => {
                this.initVPLoading(0, this.totalCnt);
            });
        });
        this.$scope.$on('$destroy', () => {
            this.BroadcastService.removeCallBack('update-notifications', $rootScope.$id);
            this.BroadcastService.removeCallBack('reset-notifications', $rootScope.$id);
        });
    }

    fetchNotifications = (pageNo): angular.IPromise<Notification[]> => {
        return this.$api.fetchNotifications(this.usrPswd, pageNo).then((n) => {
            this.totalCnt = n.totalElements;
            this.$_cache.setTotalNotifications(n.totalElements);

            let pushNotifications = this.$_cache.getPushNotifications();
            pushNotifications = pushNotifications.concat(n.notifications);
            this.$_cache.setPushNotifications(pushNotifications);
            return pushNotifications;
        });
    }

    loadNotifications = (pageNumber: number): angular.IPromise<Notification[]> => {
        const pushNotifications = this.$_cache.getPushNotifications();
        const notiLen = pushNotifications.length;
        const obj = this.dataSet.getPageStartEndIndexes(pageNumber);

        // Case 1: Data is already in the cache.
        // Use $q.when() to wrap the result in a resolved promise.
        if (notiLen >= obj.endIndex) {
            return this.$q.when(pushNotifications.slice(obj.startIndex, obj.endIndex));
        }

        // Case 2: Data needs to be fetched from the API.
        // Return the promise chain from fetchNotifications directly.
        if (this.totalCnt > 0 && this.totalCnt > obj.startIndex) {
            return this.fetchNotifications(pageNumber).then((n) => {
                // By returning a value inside .then(), you are resolving
                // the promise chain with that value.
                return n.slice(obj.startIndex, obj.endIndex);
            });
        }

        // Case 3: No data to fetch.
        // Return a resolved promise with an empty array.
        return this.$q.when([]);
    }

    initVPLoading = (numItems, totalNoti) => {
        this.dataSet = new ViewPortData({}, numItems, this.pageSize, totalNoti, 1);

        this.dataSet.fetchPage = (pageNumber) => {
            if (pageNumber > 0 && !this.dataSet.loadedPages[pageNumber - 1]) {
                //if previous page is not loaded yet then wait for that
                return;
            }
            // Set the page to null so we know it is already being fetched.
            this.dataSet.loadedPages[pageNumber] = null;
            this.loading = true;
            const loadingCompleted = (count) => {
                this.$timeout(() => {
                    this.loading = false;
                    this.$timeout(() => {
                        this.dataSet.numItems += count;
                    },
                        500);
                }, 100);
            };

            const getMappedVal = function (data) {
                return data.map(function (d) {
                    return [d]
                });
            }

            this.loadNotifications(pageNumber).then((noti) => {
                this.dataSet.loadedPages[pageNumber] = getMappedVal(noti);
                loadingCompleted(noti.length);
            });
        }

    }
    init() {
        this.itemTopIndex = 0;
        this.totalCnt = this.$_cache.getTotalNotifications();
        this.usrPswd = this.$_cache.getPassword();
        if (!!this.usrPswd) {
            if (this.totalCnt == undefined) {
                this.fetchNotifications(0).then((n) => {
                    this.initVPLoading(0, this.totalCnt);
                })
            } else {
                this.initVPLoading(0, this.totalCnt);
            }
        }
    }

    openEntity(notification: any): void {
        return this.pnSrvc.openEntity(notification);
    }
}

function pushNotification($compile, $timeout, $templateCache, $rootScope, BroadcastService): ng.IDirective {
    return {
        restrict: 'E',
        templateUrl: 'app/common/directive/push-notification/templates/push-notification.directive.html',
        replace: true,
        controller: EcvPushNotification,
        controllerAs: 'pushNotificationVm',
        scope: true,
        bindToController: {
            //
        },
        link: (scope: ng.IScope, element: ng.IAugmentedJQuery, attributes: ng.IAttributes, controller: IEcvPushNotification): void => {
            controller.init();

            $timeout(function () {
                // grab template
                const tpl = angular.element($templateCache.get('push-notification-popover.html'));
                //grab popover parts of template
                const template = {
                    title: tpl.find('.template-title').contents(),
                    content: tpl.find('.template-content').contents()
                };

                //render template with angular
                const content = $compile(template.content)(scope);
                const title = $compile(template.title)(scope);

                $(element).popover({
                    html: true,
                    placement: "bottom",
                    content: content,
                    sanitize: false,
                    title: title
                });

                $(element).on('show.bs.popover', function () {
                    // when popover opens we needs to bind the virtual repeater
                    angular.element(window).triggerHandler('resize');
                    BroadcastService.broadcast('push-notification-popover-open', [element]);
                });

                $rootScope.$on('team-popover-open', (event, data) => {
                    element.popover('hide');
                });

                $rootScope.$on('search-popover-open', (event, data) => {
                    element.popover('hide');
                });

                scope.$digest()
            });

        }
    }
}

angular.module('eCareVault.common.directives').directive('ecvPushNotification', ['$compile', '$timeout', '$templateCache', '$rootScope', 'BroadcastService', pushNotification]);
